import React from "react";
import ValenceScore from "../../Components/ValenceScore";

const Score = () => {
  return (
    <>
      <ValenceScore></ValenceScore>
    </>
  );
};

export default Score;
